module.exports = __webpack_public_path__ + "img/instagram-hover.b3ac0a3f.svg";